<script>
export default {
  name: 'Error'
}
</script>

<template>
  <div>
    <van-empty description="无效链接" image="error" />
  </div>
</template>

<style scoped lang="scss">

</style>
